import {
	InputField,
	SelectField
} from "~/components/Forms";

function BuyServiceSearchBar({filter, onSearchChange, onChange}) {

	const typeOptions = [
		{value: 'domain', label: "Tên miền"},
		{value: 'ssl', label: "Chứng chỉ bảo mật"},
		{value: 'email', label: "Email Server"},
	];

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleTypeChange = (value) => {
		if (!onChange) return;
		onChange('type', value);
	}

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField placeholder="Tên miền, số hợp đồng" onChange={handleKeywordChange} />
					<SelectField name="type" options={typeOptions} placeholder="Loại dịch vụ" onChange={handleTypeChange} ></SelectField>
				</form>
			</div>
		</div>
	)
}

export default BuyServiceSearchBar;